var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 76,
    viewBox: "0 0 77 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 0.171875C17.6302 0.171875 0.71875 17.0863 0.71875 37.9531C0.71875 58.82 17.6302 75.7344 38.5 75.7344C59.364 75.7344 76.2812 58.82 76.2812 37.9531C76.2812 17.0863 59.3669 0.171875 38.5 0.171875ZM38.1948 68.5472C21.3415 68.5472 7.67922 54.8849 7.67922 38.0316C7.67922 21.1783 21.3415 7.51597 38.1948 7.51597C55.0453 7.51597 68.7105 21.1783 68.7105 38.0316C68.7105 54.8849 55.0453 68.5472 38.1948 68.5472ZM47.0153 39.787H38.3547V25.1627C38.3547 23.5759 37.0672 22.2855 35.4804 22.2855C33.8936 22.2855 32.6032 23.573 32.6032 25.1627V42.6613C32.6032 44.251 33.8907 45.5355 35.4804 45.5355H47.0153C48.605 45.5355 49.8925 44.251 49.8925 42.6613C49.8925 41.0744 48.605 39.787 47.0153 39.787Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.16e3456d4b3e648773950593f2a442d9.svg";
export { ForwardRef as ReactComponent };